<template>
    <div class="select-tab">
        <div
            class="item"
            :class="{active: !value}"
            @click="clearSel"
            v-if="showAll"
        >
            {{allText}}
        </div>

        <div
            v-for="(item, index) in data"
            :key="index"
            class="item"
            :class="{active: checkActive(item)}"
            @click="clickHandler(item)"
        >
            {{item[props.label]}}
        </div>

        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        value: {
            type: String,
            default: '',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        props: {
            type: Object,
            default: () => ({
                label: 'name',
                value: 'id',
            }),
        },
        showAll: {
            type: Boolean,
            default: true,
        },
        allText: {
            type: String,
            default: '不限',
        },
    },
    data() {
        return {};
    },
    computed: {
        model: {
            get() {
                if (!this.multiple) {
                    // 单选
                    return this.value;

                    return;
                }

                return this.value.split(',').filter((item) => item);
            },
            set(val) {
                if (!this.multiple) {
                    // 单选
                    this.$emit('input', val);

                    return;
                }

                this.$emit('input', val.join(','));
            },
        },
    },
    methods: {
        checkActive(item) {
            var value = item[this.props.value];

            if (!this.multiple) {
                // 单选
                return this.model === value;
            }

            return this.model.includes(value);
        },
        clickHandler(item) {
            var value = item[this.props.value];

            if (!this.multiple) {
                // 单选
                this.model = value;

                this.$emit('select', this.model);

                return;
            }

            var findIndex = this.model.findIndex((item) => item === value),
                model = this.model;

            if (findIndex > -1) {
                model.splice(findIndex, 1);
            } else {
                model.push(value);
            }

            this.model = model;

            this.$emit('select', this.model);
        },
        clearSel() {
            if (!this.multiple) {
                // 单选
                this.model = '';

                this.$emit('select', this.model);

                return;
            }

            this.model = [];

            this.$emit('select', this.model);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.select-tab {
    display: flex;
    flex-wrap: wrap;

    .item {
        padding: 4px 6px;
        color: #7a7a7a;
        cursor: pointer;
        font-size: 16px;
        line-height: 1em;

        &:hover,
        &.active {
            background: $primaryColor;
            color: #ffffff;
        }

        & + .item {
            margin-left: 30px;
        }
    }
}
</style>